import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { authGuardSubmodule } from '../../auth/auth.guard';

import { TendenciaComponent } from './tendencia/tendencia.component';
import { PerfilComponent } from './perfil/perfil.component';
import { MetasComponent } from './metas/metas.component';
import { IndicadoresA1Component } from './indicadores-a1/indicadores-a1.component';
import { IndicadoresA3Component } from './indicadores-a3/indicadores-a3.component';

const routes: Routes = [
  {
      path: 'app/colocacion-comercial',
      component: ContenedorComponent,
      children: [
        {path: 'tendencia', component: TendenciaComponent, canActivate:[authGuardSubmodule]},
        {path: 'perfil', component: PerfilComponent, canActivate:[authGuardSubmodule]},
        {path: 'metas', component: MetasComponent, canActivate:[authGuardSubmodule]},
        {path: 'indicadores-A1', component: IndicadoresA1Component, canActivate:[authGuardSubmodule]},
        {path: 'indicadores-A3', component: IndicadoresA3Component, canActivate:[authGuardSubmodule]},
      ],
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ColocacionComercialRoutingModule { }
